import {
 Component, Input, Output, EventEmitter, ChangeDetectionStrategy, HostBinding
} from '@angular/core';
import { InlineEditConfig } from '../../directives/inline-edit.directive';

export type ReorderDirection = 'up' | 'down' | 'left' | 'right';

export interface ReorderEvent {
  direction: ReorderDirection;
}

@Component({
    selector: 'app-edit-controls',
    templateUrl: './edit-controls.component.html',
    styleUrls: ['./edit-controls.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EditControlsComponent {
  @Input() customClass = '';

  @HostBinding('class')
  get hostClass() {
    return `edit-controls ${this.customClass}`.trim();
  }

  @Input() showLinkIcon = false;

  @Input() linkIconTitle = 'Edit';

  @Input() linkIconName = 'link';

  @Input() showDragHandle = true;

  @Input() dragHandleTitle = 'Drag to reorder (use arrow keys)';

  @Input() dragIconName = 'drag_handle';

  @Input() deleteTitle = 'Delete item';

  @Input() deleteIconName = 'delete';

  @Input() deleteButtonColor = 'warn';

  // Inline edit inputs for link icon
  @Input() linkEditField = '';

  @Input() linkEditValue = '';

  @Input() linkEditEnabled = false;

  @Input() linkEditConfig: InlineEditConfig = { type: 'text' };

  @Input() linkEditError = false; // Whether the link field has a validation error

  @Output() deleteClick = new EventEmitter<void>();

  @Output() linkEditChange = new EventEmitter<any>();

  @Output() reorder = new EventEmitter<ReorderEvent>();

  onDeleteClick(): void {
    this.deleteClick.emit();
  }

  onLinkEditChange(event: any): void {
    this.linkEditChange.emit(event);
  }

  onDragHandleKeydown(event: KeyboardEvent): void {
    let direction: ReorderDirection | null = null;

    switch (event.key) {
      case 'ArrowUp':
        direction = 'up';
        break;
      case 'ArrowDown':
        direction = 'down';
        break;
      case 'ArrowLeft':
        direction = 'left';
        break;
      case 'ArrowRight':
        direction = 'right';
        break;
      default:
        return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.reorder.emit({ direction });
  }
}
